import React from "react";
import Slider from "react-slick";

import { Box, Button, FlexDiv, Image } from "@/components/Atoms";
import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";
import NextImage from "next/image";

import {
  FlexDom,
  IconRing,
  LHSDiv,
  RedDiv,
  RHSDiv,
  WhyShyft,
  WhyShyftText,
} from "./style";

function HealthConditions({
  onHandleRequestCallback,
  aboutTitle,
  aboutSubtitle,
  title,
  ctaTitle,
  healthConditions,
}) {
  const settings = {
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: healthConditions?.length > 7,
    arrows: false,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 5,
          dots: true,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          dots: true,
          infinite: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: false,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <FlexDiv flexDirection={"column"} mb={"48px"} pt={"53px"}>
        <WhyShyft flexDirection={"column"}>
          <Typography variant="title1" mb={"22px"} color={theme.colors.gray_90}>
            {aboutTitle}
          </Typography>
          <WhyShyftText
            variant="header3"
            color={theme.colors.link2Color}
            fontFamily="var(--font-600)"
            lineHeight={"31px"}
          >
            {aboutSubtitle}
          </WhyShyftText>
        </WhyShyft>
      </FlexDiv>
      <RedDiv flexDirection={"column"}>
        <FlexDom>
          <LHSDiv flexDirection={"column"}>
            <Typography
              fontFamily={"var(--font-700)"}
              variant="paragraph1"
              color={theme.colors.shadeRed}
              mb={"14px"}
            >
              {title}
            </Typography>
            {ctaTitle && (
              <FlexDiv>
                <Button
                  variant={"primary"}
                  onClick={onHandleRequestCallback}
                  fontSize={"15px"}
                >
                  {ctaTitle}
                </Button>
              </FlexDiv>
            )}
          </LHSDiv>
          <RHSDiv>
            <Slider {...settings}>
              {healthConditions?.map((item, index) => {
                return (
                  <Box key={index}>
                    <FlexDiv
                      flexDirection={"column"}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography
                        variant="link1"
                        href={
                          item.link?.endsWith("/")
                            ? item.link
                            : item.link
                            ? `${item.link}/`
                            : null
                        }
                        display={"flex"}
                        flexDirection={"column"}
                        alignItems="center"
                      >
                        <IconRing mb={"22px"}>
                          <NextImage
                            src={item.img}
                            height={78}
                            width={78}
                            alt=""
                          />
                        </IconRing>
                        <Typography
                          variant="title3"
                          fontSize="14px"
                          color={theme.colors.gray_100}
                          textAlign="center"
                        >
                          {item.text}
                        </Typography>
                      </Typography>
                    </FlexDiv>
                  </Box>
                );
              })}
            </Slider>
          </RHSDiv>
        </FlexDom>
      </RedDiv>
    </>
  );
}

export default HealthConditions;
